import { render } from "./AnimatedNumber.vue?vue&type=template&id=214737cb"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__